import { PAID_ORDERS, PAID_ORDERS_ERROR } from "../actions/types";

const initialState = {
  data: {
    data: [],
    totalRecords: 0,
  },
  error: null,
  loading: true,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PAID_ORDERS:
      return {
        ...state,
        data: payload,
        error: null,
        loading: false,
      };
    case PAID_ORDERS_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
